import { useState } from 'react';

const FAQ_DATA = [
  {
    q: '黑料吃瓜在线观看需要付费吗？',
    a: '完全不需要！黑料吃瓜在线观看平台所有视频内容均为免费观看，包括黑料吃瓜高清视频、黑料吃瓜短视频和黑料吃瓜最新视频，支持免费在线播放，无需任何付费订阅。',
  },
  {
    q: '黑料吃瓜视频内容多久更新一次？',
    a: '我们的编辑团队全天候追踪全网热点，每日更新50+条黑料吃瓜内容。黑料吃瓜网在线观看平台坚持第一时间为您带来最新最热的吃瓜资讯，确保您不错过任何精彩内容。',
  },
  {
    q: '黑料吃瓜短视频和高清视频有什么区别？',
    a: '黑料吃瓜短视频适合快速浏览，时长通常在1-3分钟，方便您碎片化时间观看。黑料吃瓜高清视频则提供更完整的娱乐资讯和深度内容，画质更高，适合沉浸式观看体验。',
  },
  {
    q: '如何在手机上观看黑料吃瓜最新视频？',
    a: '您可以通过手机浏览器直接访问黑料吃瓜网在线观看平台，也可以在应用商店下载黑料吃瓜App。App支持离线缓存、个性化推荐和消息推送，让您随时随地畅享吃瓜内容。',
  },
  {
    q: '黑料吃瓜的内容来源可靠吗？',
    a: '我们严格把控内容质量，所有黑料吃瓜在线观看内容均来自公开娱乐资讯和可靠渠道。同时我们欢迎用户投稿爆料，经编辑审核后及时发布，确保信息的真实性和时效性。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-question-answer-line text-accent-500 mr-2"></i>常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">快速了解黑料吃瓜平台</p>
        </div>

        <div className="space-y-3">
          {FAQ_DATA.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 ${
                  openIdx === idx ? 'bg-primary-500 rotate-45' : 'bg-background-200'
                }`}>
                  <i className={`text-sm ${openIdx === idx ? 'text-white' : 'text-foreground-500'} ri-add-line`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}